// extracted by mini-css-extract-plugin
module.exports = {"centered":"Loading_centered__34-5Z","fullscreen":"Loading_fullscreen__b0L-C"};